"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorSetFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ValidatorSetFactory = /** @class */ (function (_super) {
    __extends(ValidatorSetFactory, _super);
    function ValidatorSetFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ValidatorSetFactory.prototype.deploy = function (_seedValidators, _testSystemAddress, overrides) {
        return _super.prototype.deploy.call(this, _seedValidators, _testSystemAddress, overrides || {});
    };
    ValidatorSetFactory.prototype.getDeployTransaction = function (_seedValidators, _testSystemAddress, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _seedValidators, _testSystemAddress, overrides || {});
    };
    ValidatorSetFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ValidatorSetFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ValidatorSetFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ValidatorSetFactory;
}(contracts_1.ContractFactory));
exports.ValidatorSetFactory = ValidatorSetFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'address[]',
                name: '_seedValidators',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: '_testSystemAddress',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: '_parent_hash',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'address[]',
                name: '_new_set',
                type: 'address[]',
            },
        ],
        name: 'InitiateChange',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [],
        name: 'BLOCKS_INTERVAL',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'LUCK_TRIES',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MAX_VALIDATORS',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'PERCENT_UNIQUE',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'SYSTEM_ADDRESS',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'finalizeChange',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getNextValidators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getValidators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'initiateChange',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastFinalizeChangeBlock',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_BLOCKS_INTERVAL',
                type: 'uint256',
            },
        ],
        name: 'setBlocksInterval',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_LUCK_TRIES',
                type: 'uint256',
            },
        ],
        name: 'setLuckTries',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_MAX_VALIDATORS',
                type: 'uint256',
            },
        ],
        name: 'setMaxValidators',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_PERCENT_UNIQUE',
                type: 'uint256',
            },
        ],
        name: 'setPercentUnique',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=ValidatorSetFactory.js.map